"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./ProgressBar.scss");
function ProgressBar(props) {
    return (React.createElement("div", { className: 'progress' },
        React.createElement("div", { className: 'progress-bar', role: 'progressbar', "aria-valuenow": props.progress, "aria-valuemin": 0, "aria-valuemax": 100, style: { width: props.progress + "%" } })));
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map